module.exports = __webpack_public_path__ + "static/media/HuaweiIcon.49619986.svg";